'use client';
import { createSafeContext } from '@mantine/core';

const [RichTextEditorProvider, useRichTextEditorContext] = createSafeContext("RichTextEditor component was not found in tree");

export { RichTextEditorProvider, useRichTextEditorContext };
//# sourceMappingURL=RichTextEditor.context.mjs.map
